import React from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import GroupsOverview from '../integrations/lavva/modules/dashboard/modules/groups-overview/groups-overview';
import Instructions from '../integrations/lavva/modules/dashboard/modules/instructions/instructions';
import TariffOverview from '../integrations/lavva/modules/dashboard/modules/tariff-overview/tariff-overview';
import { BluetoothLayout } from '../layouts/bluetooth-layout';
import { relativeAddBluetoothPath, withRouteWrapper } from '../utils/routes/route-wrapper';
import {
  ChannelList,
  Dashboard,
  ChannelConfiguration,
  ChannelDetails,
  GroupList,
  ActionList,
  GroupCreate,
  GroupEdit,
  DeviceList,
  DeviceDetails,
  ChannelsVisibility,
  GroupSort,
  GroupSortChannels,
  ActionCreate,
  ActionCreateTasks,
  ActionTasksTypes,
  ActionTasksVariants,
  ActionDeviceVariants,
  ActionChannelSettings,
  ActionEdit,
  ActionEditTasks,
  Groups,
} from './integration-routes';
import { ROUTES } from './routes';
import ExalusActionCreateConditions from '../integrations/exalus/modules/action-create/conditions';
import ExalusActionSources from '../integrations/exalus/modules/action-create/conditions/action-sources';
import ExalusDeviceParameters from '../integrations/exalus/modules/action-create/conditions/action-sources/device-parameters';
import ExalusDeviceSource from '../integrations/exalus/modules/action-create/conditions/action-sources/device-source';
import ExalusScenarioSource from '../integrations/exalus/modules/action-create/conditions/action-sources/scenario-source';
import ExalusScheduleSource from '../integrations/exalus/modules/action-create/conditions/action-sources/schedule-source';
import ExalusActionConditionsTypes from '../integrations/exalus/modules/action-create/conditions/conditions-types';
import ExalusActionTaskDelay from '../integrations/exalus/modules/action-create/tasks/task-variants/delay-view';
import ExalusActionTaskLock from '../integrations/exalus/modules/action-create/tasks/task-variants/lock-view';
import ExalusActionTaskNotify from '../integrations/exalus/modules/action-create/tasks/task-variants/notify-view';
import ExalusActionDetails from '../integrations/exalus/modules/action-details';
import AddDevices from '../integrations/exalus/modules/add-devices';
import CentralActionByTypeDetails from '../integrations/exalus/modules/central-action-by-type-details';
import CentralActionDetails from '../integrations/exalus/modules/central-action-details';
import BlindAutoCalibration from '../integrations/exalus/modules/channel-configuration/forms/common/auto-calibration';
import DeviceRemotes from '../integrations/exalus/modules/channel-configuration/forms/common/device-remotes';
import DeviceUpdate from '../integrations/exalus/modules/channel-configuration/forms/common/update';
import Srp22Calibration from '../integrations/exalus/modules/channel-configuration/forms/srp/calibration-srp22';
import ZfBidiCalibration from '../integrations/exalus/modules/channel-configuration/forms/zf-bidi/calibration';
import Chat from '../integrations/exalus/modules/chat';
import ExalusControllerSettings from '../integrations/exalus/modules/controller-settings';
import ControllerUpdates from '../integrations/exalus/modules/controller-settings/updates';
import LocationMap from '../integrations/exalus/modules/controller-settings/location-map';
import UpdatesSettings from '../integrations/exalus/modules/controller-settings/updates-settings';
import ImportExportConfiguration from '../integrations/exalus/modules/controller-settings/import-export';
import CreateAccountOffer from '../integrations/exalus/modules/groups/components/create-account-popup';
import ExalusIntegrationCreate from '../integrations/exalus/modules/integration-create';
import ExalusIntegrationLogin from '../integrations/exalus/modules/integration-login';
import ExalusQRCodeAuth from '../integrations/exalus/modules/integration-qr-auth';
import ExalusLogin from '../integrations/exalus/modules/login';
import ExalusAddDns from '../integrations/exalus/modules/network/add-dns';
import ExalusNetworkSettings from '../integrations/exalus/modules/network/network-settings';
import ExalusNetworkStaticSettings from '../integrations/exalus/modules/network/static-settings';
import ExalusUsersList from '../integrations/exalus/modules/users-list';
import ExalusChangePassword from '../integrations/exalus/modules/users-list/change-password';
import ExalusUserCreate from '../integrations/exalus/modules/users-list/create-user';
import ExalusUserEdit from '../integrations/exalus/modules/users-list/edit-user';
import ExalusUserDetails from '../integrations/exalus/modules/users-list/user-details';
import ActionChannelSort from '../integrations/lavva/modules/action-channels-sort';
import ActionCreateBasic from '../integrations/lavva/modules/action-create-basic';
import ActionDetails from '../integrations/lavva/modules/action-details';
import ActionEditChannels from '../integrations/lavva/modules/action-edit-channels';
import ActionEditName from '../integrations/lavva/modules/action-edit-name';
import TariffConfiguration from '../integrations/lavva/modules/channel-configuration/components/tariff';
import MeasurementDetails from '../integrations/lavva/modules/channel-details/measurements/details';
import DeviceAddBluetooth from '../integrations/lavva/modules/device-add/pages';
import DeviceAddBluetoothIdentify from '../integrations/lavva/modules/device-add/pages/identify';
import DeviceAddBluetoothNetwork from '../integrations/lavva/modules/device-add/pages/network';
import DeviceAddBluetoothSuccess from '../integrations/lavva/modules/device-add/pages/success/success';
import DeviceUpdateBluetoothSuccess from '../integrations/lavva/modules/device-add/pages/success/update-success';
import DeviceAddBluetoothSetWifiSuccess from '../integrations/lavva/modules/device-add/pages/success/wifi-success';
import DeviceAddBluetoothUpdate from '../integrations/lavva/modules/device-add/pages/update/update';
import WisniowskiDriveAddStart from '../integrations/lavva/modules/device-add/pages/wisniowski/drive-add-start';
import WisniowskiDriveAddSuccess from '../integrations/lavva/modules/device-add/pages/wisniowski/drive-add-success';
import WisniowskiDriveAddTutorialStep0 from '../integrations/lavva/modules/device-add/pages/wisniowski/drive-add-tutorial/step-0';
import WisniowskiDriveAddTutorialStep1 from '../integrations/lavva/modules/device-add/pages/wisniowski/drive-add-tutorial/step-1';
import WisniowskiDriveAddTutorialStep2 from '../integrations/lavva/modules/device-add/pages/wisniowski/drive-add-tutorial/step-2';
import DeviceWifiConfiguration from '../integrations/lavva/modules/device-wifi-configuration';
import RgbSceneForm from '../integrations/lavva/modules/rgb-scene-form';
import TriggerDetails from '../integrations/lavva/modules/trigger-details';
import TriggerForm from '../integrations/lavva/modules/trigger-form';
import Demo from '../modules/demo/demo';
import InstallationCreate from '../modules/installation-create';
import IntegrationsList from '../modules/installation-create/integration-list';
import InstallationCreated from '../modules/installation-created';
import InstallationList from '../modules/installation-list';
import InstallationSettings from '../modules/installation-settings';
import RemoveInstallation from '../modules/installation-settings/installation/installation-remove';
import ShareAccessCount from '../modules/installation-share/access-count';
import ShareAccessTime from '../modules/installation-share/access-time';
import InstallationSummaryForward from '../modules/installation-share/forward-summary-installation';
import ChannelsShare from '../modules/installation-share/share-channels';
import ChannelsShareEdit from '../modules/installation-share/share-channels-edit';
import ShareEmail from '../modules/installation-share/share-email';
import GroupsShare from '../modules/installation-share/share-groups';
import GroupsShareEdit from '../modules/installation-share/share-groups-edit';
import ShareRestriction from '../modules/installation-share/share-restriction';
import ShareRole from '../modules/installation-share/share-role';
import InstallationShareSubject from '../modules/installation-share/share-subject';
import SharedInstallations from '../modules/installation-share/shared-installation';
import SharedUser from '../modules/installation-share/shared-user';
import InvitationSummary from '../modules/installation-share/summary-share-invitation/invitation';
import ShareSummary from '../modules/installation-share/summary-share-invitation/share';
import NotificationDetails from '../modules/notification-details';
import NotificationList from '../modules/notification-list';
import PrivacyPage from '../modules/privacy';
import RodoPage from '../modules/rodo';
import Settings from '../modules/settings';
import Credentials from '../modules/credentials/credentials';
import Store from '../modules/store';
import StoreDeviceDetails from '../modules/store-device-details';
import SupportPage from '../modules/support';
import TermsPage from '../modules/terms';
import UserManual from '../modules/user-manual';
import TauronG13s from '../integrations/lavva/modules/dashboard/modules/tauron-g13s/tauron-g13s';
import MeterDevices from '../integrations/lavva/modules/dashboard/modules/meter-devices/meter-devices';

export const router = createBrowserRouter([
  {
    path: ROUTES.Root(),
    element: withRouteWrapper(Groups, true),
  },
  {
    path: ROUTES.Notification(),
    element: withRouteWrapper(NotificationList),
  },
  {
    path: ROUTES.NotificationDetails(),
    element: withRouteWrapper(NotificationDetails),
  },
  {
    path: ROUTES.Dashboard(),
    element: withRouteWrapper(Dashboard, true),
  },
  {
    path: ROUTES.Settings(),
    element: withRouteWrapper(Settings, true),
  },
  {
    path: ROUTES.Credentials(),
    element: withRouteWrapper(Credentials),
  },
  {
    path: ROUTES.Channel(),
    element: withRouteWrapper(ChannelList, true),
  },
  {
    path: ROUTES.ChannelsVisibility(),
    element: withRouteWrapper(ChannelsVisibility),
  },
  {
    path: ROUTES.ChannelDetails(),
    element: withRouteWrapper(ChannelDetails),
  },
  {
    path: ROUTES.Device(),
    element: withRouteWrapper(DeviceList),
  },
  {
    path: ROUTES.DeviceSettings(),
    element: withRouteWrapper(DeviceDetails),
  },
  {
    path: ROUTES.DeviceWifiConfiguration(),
    element: withRouteWrapper(DeviceWifiConfiguration),
  },
  {
    path: ROUTES.FavouriteGroupEdit(),
    element: withRouteWrapper(GroupEdit),
  },
  {
    path: ROUTES.GroupList(),
    element: withRouteWrapper(GroupList),
  },
  {
    path: ROUTES.GroupSort(),
    element: withRouteWrapper(GroupSort),
  },
  {
    path: ROUTES.GroupSortChannels(),
    element: withRouteWrapper(GroupSortChannels),
  },
  {
    path: ROUTES.GroupCreate(),
    element: withRouteWrapper(GroupCreate),
  },
  {
    path: ROUTES.GroupEdit(),
    element: withRouteWrapper(GroupEdit),
  },
  {
    path: ROUTES.InstallationGroupsShare(),
    element: withRouteWrapper(GroupsShare),
  },
  {
    path: ROUTES.InstallationChannelsShare(),
    element: withRouteWrapper(ChannelsShare),
  },
  {
    path: ROUTES.Terms(),
    element: withRouteWrapper(TermsPage),
  },
  {
    path: ROUTES.Privacy(),
    element: withRouteWrapper(PrivacyPage),
  },
  {
    path: ROUTES.Support(),
    element: withRouteWrapper(SupportPage),
  },
  {
    path: ROUTES.Rodo(),
    element: withRouteWrapper(RodoPage),
  },
  {
    path: ROUTES.Store(),
    element: withRouteWrapper(Store),
  },
  {
    path: ROUTES.StoreDeviceDetails(),
    element: withRouteWrapper(StoreDeviceDetails),
  },
  {
    path: ROUTES.Installation(),
    element: withRouteWrapper(InstallationList),
  },
  {
    path: ROUTES.InstallationCreate(),
    element: withRouteWrapper(InstallationCreate),
  },
  {
    path: ROUTES.InstallationCreated(),
    element: withRouteWrapper(InstallationCreated),
  },
  {
    path: ROUTES.IntegrationsList(),
    element: withRouteWrapper(IntegrationsList),
  },
  {
    path: ROUTES.InstallationSettings(),
    element: withRouteWrapper(InstallationSettings),
  },
  {
    path: ROUTES.InstallationForwardSummary(),
    element: withRouteWrapper(InstallationSummaryForward),
  },
  {
    path: ROUTES.InstallationRemove(),
    element: withRouteWrapper(RemoveInstallation),
  },
  {
    path: ROUTES.InstallationShared(),
    element: withRouteWrapper(SharedInstallations),
  },
  {
    path: ROUTES.SharedUser(),
    element: withRouteWrapper(SharedUser),
  },
  {
    path: ROUTES.InstallationShareEmail(),
    element: withRouteWrapper(ShareEmail),
  },
  {
    path: ROUTES.InstallationShareSubject(),
    element: withRouteWrapper(InstallationShareSubject),
  },
  {
    path: ROUTES.InstallationShareRole(),
    element: withRouteWrapper(ShareRole),
  },
  {
    path: ROUTES.UserSharedGroups(),
    element: withRouteWrapper(GroupsShareEdit),
  },
  {
    path: ROUTES.UserSharedChannels(),
    element: withRouteWrapper(ChannelsShareEdit),
  },
  {
    path: ROUTES.InstallationShareRestriction(),
    element: withRouteWrapper(ShareRestriction),
  },
  {
    path: ROUTES.InstallationShareAccessCount(),
    element: withRouteWrapper(ShareAccessCount),
  },
  {
    path: ROUTES.InstallationShareAccessTime(),
    element: withRouteWrapper(ShareAccessTime),
  },
  {
    path: ROUTES.InstallationSummaryShare(),
    element: withRouteWrapper(ShareSummary),
  },
  {
    path: ROUTES.InvitationSummary(),
    element: withRouteWrapper(InvitationSummary),
  },
  {
    path: ROUTES.ActionList(),
    element: withRouteWrapper(ActionList, true),
  },
  {
    path: ROUTES.TauronG13s(),
    element: withRouteWrapper(TauronG13s),
  },
  {
    path: ROUTES.MeterDevices(),
    element: withRouteWrapper(MeterDevices),
  },
  {
    path: ROUTES.TariffOverview(),
    element: withRouteWrapper(TariffOverview),
  },
  {
    path: ROUTES.GroupsOverview(),
    element: withRouteWrapper(GroupsOverview),
  },
  {
    path: ROUTES.Instructions(),
    element: withRouteWrapper(Instructions),
  },
  {
    path: ROUTES.ActionEditChannels(),
    element: withRouteWrapper(ActionEditChannels),
  },
  {
    path: ROUTES.ActionEditName(),
    element: withRouteWrapper(ActionEditName),
  },
  {
    path: ROUTES.ActionCreate(),
    element: withRouteWrapper(ActionCreate),
  },
  {
    path: ROUTES.ActionCreateTasks(),
    element: withRouteWrapper(ActionCreateTasks),
  },
  {
    path: ROUTES.ActionChannelsSort(),
    element: withRouteWrapper(ActionChannelSort),
  },
  {
    path: ROUTES.ActionCreateBasic(),
    element: withRouteWrapper(ActionCreateBasic),
  },
  {
    path: ROUTES.TriggerCreate(),
    element: withRouteWrapper(TriggerForm),
  },
  {
    path: ROUTES.TriggerEdit(),
    element: withRouteWrapper(TriggerForm),
  },
  {
    path: ROUTES.RgbSceneCreate(),
    element: withRouteWrapper(RgbSceneForm),
  },
  {
    path: ROUTES.CreateAccountOffer(),
    element: withRouteWrapper(CreateAccountOffer),
  },
  {
    path: ROUTES.ActionDetails(),
    element: withRouteWrapper(ActionDetails),
  },
  {
    path: ROUTES.TriggerDetails(),
    element: withRouteWrapper(TriggerDetails),
  },
  {
    path: ROUTES.ChannelConfiguration(),
    element: withRouteWrapper(ChannelConfiguration),
  },
  {
    path: ROUTES.TariffConfiguration(),
    element: withRouteWrapper(TariffConfiguration),
  },
  {
    path: ROUTES.ExalusIntegrationCreate(),
    element: withRouteWrapper(ExalusIntegrationCreate),
  },
  {
    path: ROUTES.ExalusAuthorization(),
    element: withRouteWrapper(ExalusIntegrationLogin),
  },
  {
    path: ROUTES.ExalusQRCodeAuthorization(),
    element: withRouteWrapper(ExalusQRCodeAuth),
  },
  {
    path: ROUTES.ExalusLogin(),
    element: withRouteWrapper(ExalusLogin),
  },
  {
    path: ROUTES.CentralAction(),
    element: withRouteWrapper(CentralActionDetails),
  },
  {
    path: ROUTES.CentralActionByType(),
    element: withRouteWrapper(CentralActionByTypeDetails),
  },
  {
    path: ROUTES.AddExalusDevices(),
    element: withRouteWrapper(AddDevices),
  },
  {
    path: ROUTES.FacadeCalibration(),
    element: withRouteWrapper(ZfBidiCalibration),
  },
  {
    path: ROUTES.Srp22Calibration(),
    element: withRouteWrapper(Srp22Calibration),
  },
  {
    path: ROUTES.DeviceUpdate(),
    element: withRouteWrapper(DeviceUpdate),
  },
  {
    path: ROUTES.BlindAutoCalibration(),
    element: withRouteWrapper(BlindAutoCalibration),
  },
  {
    path: ROUTES.ExalusUsersList(),
    element: withRouteWrapper(ExalusUsersList),
  },
  {
    path: ROUTES.UserDetails(),
    element: withRouteWrapper(ExalusUserDetails),
  },
  {
    path: ROUTES.UserEdit(),
    element: withRouteWrapper(ExalusUserEdit),
  },
  {
    path: ROUTES.ChangeUserPassword(),
    element: withRouteWrapper(ExalusChangePassword),
  },
  {
    path: ROUTES.UserCreate(),
    element: withRouteWrapper(ExalusUserCreate),
  },
  {
    path: ROUTES.UserManual(),
    element: withRouteWrapper(UserManual),
  },
  {
    path: ROUTES.ExalusControllerSettings(),
    element: withRouteWrapper(ExalusControllerSettings),
  },
  {
    path: ROUTES.ExalusControllerUpdates(),
    element: withRouteWrapper(ControllerUpdates),
  },
  {
    path: ROUTES.ExalusControllerLocation(),
    element: withRouteWrapper(LocationMap),
  },
  {
    path: ROUTES.ExalusControllerUpdatesSettings(),
    element: withRouteWrapper(UpdatesSettings),
  },
  {
    path: ROUTES.ExalusControllerImportExport(),
    element: withRouteWrapper(ImportExportConfiguration),
  },
  {
    path: ROUTES.ExalusNetworkSettings(),
    element: withRouteWrapper(ExalusNetworkSettings),
  },
  {
    path: ROUTES.ExalusActionCreateConditions(),
    element: withRouteWrapper(ExalusActionCreateConditions),
  },
  {
    path: ROUTES.ExalusActionConditionsTypes(),
    element: withRouteWrapper(ExalusActionConditionsTypes),
  },
  {
    path: ROUTES.ActionTasksTypes(),
    element: withRouteWrapper(ActionTasksTypes),
  },
  {
    path: ROUTES.ActionTasksVariants(),
    element: withRouteWrapper(ActionTasksVariants),
  },
  {
    path: ROUTES.DeviceVariants(),
    element: withRouteWrapper(ActionDeviceVariants),
  },
  {
    path: ROUTES.ActionChannelSettings(),
    element: withRouteWrapper(ActionChannelSettings),
  },
  {
    path: ROUTES.ExalusActionTaskDelay(),
    element: withRouteWrapper(ExalusActionTaskDelay),
  },
  {
    path: ROUTES.ExalusActionTaskLock(),
    element: withRouteWrapper(ExalusActionTaskLock),
  },
  {
    path: ROUTES.ExalusActionTaskNotify(),
    element: withRouteWrapper(ExalusActionTaskNotify),
  },
  {
    path: ROUTES.ExalusActionSources(),
    element: withRouteWrapper(ExalusActionSources),
  },
  {
    path: ROUTES.ExalusDeviceSource(),
    element: withRouteWrapper(ExalusDeviceSource),
  },
  {
    path: ROUTES.ExalusScheduleSource(),
    element: withRouteWrapper(ExalusScheduleSource),
  },
  {
    path: ROUTES.ExalusScenarioSource(),
    element: withRouteWrapper(ExalusScenarioSource),
  },
  {
    path: ROUTES.ExalusDeviceParameters(),
    element: withRouteWrapper(ExalusDeviceParameters),
  },
  {
    path: ROUTES.ExalusActionDetails(),
    element: withRouteWrapper(ExalusActionDetails),
  },
  {
    path: ROUTES.ActionEdit(),
    element: withRouteWrapper(ActionEdit),
  },
  {
    path: ROUTES.ActionEditConditions(),
    element: withRouteWrapper(ExalusActionCreateConditions),
  },
  {
    path: ROUTES.ActionEditTasks(),
    element: withRouteWrapper(ActionEditTasks),
  },
  {
    path: ROUTES.DeviceRemotes(),
    element: withRouteWrapper(DeviceRemotes),
  },
  {
    path: ROUTES.ExalusDnsAdd(),
    element: withRouteWrapper(ExalusAddDns),
  },
  {
    path: ROUTES.ExalusNetworkStaticSettings(),
    element: withRouteWrapper(ExalusNetworkStaticSettings),
  },
  {
    path: ROUTES.Chat(),
    element: withRouteWrapper(Chat, true),
  },
  {
    path: ROUTES.MeasurementDetails(),
    element: withRouteWrapper(MeasurementDetails),
  },
  {
    path: ROUTES.Demo(),
    element: withRouteWrapper(Demo),
  },
  {
    path: ROUTES.DeviceAddBluetooth(),
    element: <BluetoothLayout />,
    children: [
      {
        path: '',
        element: withRouteWrapper(DeviceAddBluetooth),
      },
      {
        path: relativeAddBluetoothPath(ROUTES.DeviceAddBluetoothIdentify()),
        element: withRouteWrapper(DeviceAddBluetoothIdentify),
      },
      {
        path: relativeAddBluetoothPath(ROUTES.DeviceAddBluetoothNetwork()),
        element: withRouteWrapper(DeviceAddBluetoothNetwork),
      },
      {
        path: relativeAddBluetoothPath(ROUTES.DeviceAddBluetoothSuccess()),
        element: withRouteWrapper(DeviceAddBluetoothSuccess),
      },
      {
        path: relativeAddBluetoothPath(ROUTES.DeviceUpdateBluetoothSuccess()),
        element: withRouteWrapper(DeviceUpdateBluetoothSuccess),
      },
      {
        path: relativeAddBluetoothPath(ROUTES.DeviceAddBluetoothSetWifiSuccess()),
        element: withRouteWrapper(DeviceAddBluetoothSetWifiSuccess),
      },
      {
        path: relativeAddBluetoothPath(ROUTES.DeviceAddBluetoothUpdate()),
        element: withRouteWrapper(DeviceAddBluetoothUpdate),
      },
      {
        path: relativeAddBluetoothPath(ROUTES.DeviceAddBluetoothWisniowskiStart()),
        element: withRouteWrapper(WisniowskiDriveAddStart),
      },
      {
        path: relativeAddBluetoothPath(ROUTES.DeviceAddBluetoothWisniowskiTutorialStep0()),
        element: withRouteWrapper(WisniowskiDriveAddTutorialStep0),
      },
      {
        path: relativeAddBluetoothPath(ROUTES.DeviceAddBluetoothWisniowskiTutorialStep1()),
        element: withRouteWrapper(WisniowskiDriveAddTutorialStep1),
      },
      {
        path: relativeAddBluetoothPath(ROUTES.DeviceAddBluetoothWisniowskiTutorialStep2()),
        element: withRouteWrapper(WisniowskiDriveAddTutorialStep2),
      },
      {
        path: relativeAddBluetoothPath(ROUTES.DeviceAddBluetoothWisniowskiSuccess()),
        element: withRouteWrapper(WisniowskiDriveAddSuccess),
      },
    ],
  },

  {
    path: '*',
    element: <Navigate to={ROUTES.Root()} replace />,
  },
]);

export const RouterSwitch: React.FC = () => <RouterProvider router={router} future={{ v7_startTransition: false }} />;
